<template>
  <v-dialog v-model="isShow" persistent max-width="700px">
    <v-card :class="classContents">
      <v-card-title>
        <h3>{{ $t('alert.kpi.form.title') }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon x-small @click="close()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" class="pa-3 pr-4">
        <v-row>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-col cols="3"><span class="label">{{ this.$t('alert.description') }}</span></v-col>
          <v-col cols="9"><v-text-field v-model="formData.message" outlined dense :disabled="true"/></v-col>
        </v-row>
        <v-row v-if="formData.alertType != 'EVENT'">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-col cols="3"><span class="label">{{ this.$t('alert.warning') }}</span></v-col>
          <v-col cols="3"><v-text-field v-model="formData.warningValue" outlined dense type="number"/></v-col>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-col cols="3"><span class="label">{{ this.$t('alert.critical') }}</span></v-col>
          <v-col cols="3"><v-text-field v-model="formData.criticalValue" outlined dense type="number"/></v-col>
        </v-row>
        <v-row v-if="formData.alertType != 'EVENT'">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-col cols="3"><span class="label">{{ this.$t('alert.count') }}</span></v-col>
          <v-col cols="3"><v-text-field v-model="formData.collectCount" class="w-auto" outlined dense type="number"/></v-col>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-col cols="3"><span class="label">{{ this.$t('alert.decimalFormat') }}</span></v-col>
          <v-col cols="3"><v-text-field v-model="formData.unitSymbol" class="w-auto" outlined dense :disabled="true"/></v-col>
        </v-row>
        <v-row v-if="formData.alertType != 'EVENT'">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-col cols="3"><span class="label">{{ this.$t('alert.active') }}</span></v-col>
          <v-col cols="3"><v-checkbox v-model="formData.active" :disabled="formData.active === undefined" class="alert-chk-mgt" dense/></v-col>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-col cols="3"><span class="label">{{ this.$t('alert.continuousAlert') }}</span></v-col>
          <v-col cols="3"><v-checkbox v-model="formData.continuousAlert" :disabled="formData.continuousAlert === undefined" class="kpi-chk-mgt" dense/></v-col>
        </v-row>
        <v-row v-if="formData.alertType != 'EVENT'">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-col cols="3"><span class="label">{{ this.$t('alert.failback') }}</span></v-col>
          <v-col cols="3"><v-checkbox v-model="formData.failback" :disabled="formData.failback === undefined" class="alert-chk-mgt" dense/></v-col>
          <v-col cols="6">
            <div class="my-1" v-if="isShowAlertUserBtn">
              <v-btn @click="openAlertUser()" small color="primary">{{ this.$t('alert.user.settings') }}</v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="formData.alertType == 'EVENT'">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-col cols="3"><span class="label">{{ this.$t('alert.active') }}</span></v-col>
          <v-col cols="3"><v-checkbox v-model="formData.active" :disabled="formData.active === undefined" class="alert-chk-mgt" dense/></v-col>
          <v-col cols="6">
            <div class="my-1" v-if="isShowAlertUserBtn">
              <v-btn @click="openAlertUser()" small color="primary">{{ this.$t('alert.user.settings') }}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="save()" :loading="loading" small color="primary">{{ this.$t('common.save') }}</v-btn>
        <v-btn @click="close()" small color="primary">{{ this.$t('common.cancel') }}</v-btn>
      </v-card-actions>
      <AlertUser ref="kpiAlertUserComp" :userFormData="formData" uiType="kpi" />
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from '@/api/common/instances';
import AlertUser from './components/AlertUser';

export default {
  name: 'KpiForm',
  components: {
    AlertUser,
  },
  props: {
    isShow: Boolean,
    formData: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isShowAlertUserBtn() {
      return this.formData.systemId !== '*' ? true : false;
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  methods: {
    openAlertUser() {
      this.$refs.kpiAlertUserComp.$data.userShow = true;
    },
    async save() {
      const rspn = await api.put('/preference/alert-codes', this.formData);
      if (rspn.status == 200) {
        this.$dialog.info(this.$t('common.successful'));
        this.$emit('formClose', 'save');
      }
    },
    close() {
      this.$emit('formClose', 'cancel');
    },
  },
};
</script>
<style scoped>
.label {
  padding-left: 10px;
}
.v-text-field {
  width: 100%;
}
</style>
